<header>
  <h2>{{ title }}</h2>

  <py-notification class="my-5" [type]="'info'" [message]="infoText"></py-notification>

  <ng-content></ng-content>
</header>
